import { useState, type FormEvent } from "react";
import { useAuth } from "../hooks/useAuth";
import { Button } from "./Button";

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  "auth/invalid-email": "Invalid email address",
  "auth/user-disabled": "This account has been disabled",
  "auth/user-not-found": "No account found with this email",
  "auth/wrong-password": "Incorrect password",
  "auth/invalid-credential": "Invalid email or password",
  "auth/too-many-requests": "Too many attempts. Please try again later.",
};

export function LoginView() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      await login(email.trim(), password);
    } catch (err) {
      const code = (err as { code?: string }).code ?? "";
      setError(AUTH_ERROR_MESSAGES[code] || "An error occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-[calc(100vh-32px)] flex-col">
      <div className="flex flex-1 flex-col justify-center">
        <h2 className="mb-6 text-xl font-semibold">OpsMate Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="email" className="mb-1 block text-sm font-medium">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-(--border-color,#d1d5db) bg-(--input-background,#fff) px-3 py-2 text-sm text-(--text-color,#111) focus:border-(--accent-color,#3b82f6) focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
            />
          </div>
          <div className="mb-4">
            <label htmlFor="password" className="mb-1 block text-sm font-medium">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-md border border-(--border-color,#d1d5db) bg-(--input-background,#fff) px-3 py-2 text-sm text-(--text-color,#111) focus:border-(--accent-color,#3b82f6) focus:ring-2 focus:ring-blue-500/20 focus:outline-none"
            />
          </div>
          <Button type="submit" disabled={submitting}>
            Sign In
          </Button>
          {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
        </form>
      </div>
    </div>
  );
}
